import React from 'react';
import { PsPage } from '../../../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import TasksCard from '../components/TasksCard';
import { BreadcrumbsManagerInstance } from '../../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../../shared/breadcrumbs/Breadcrumbs';

export default class TasksScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES,
            Breadcrumbs.MY_OUTSOURCES_TASKS,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_MIS_TAREAS')} breadcrumbs={breadcrumbs}>
                <TasksCard/>
            </PsPage>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/tasks/list/screens/TasksScreen.js